import React from 'react';
import classNames from 'classnames';
import bindAll from 'lodash.bindall';
import { defineMessages, FormattedMessage, injectIntl, intlShape } from 'react-intl';

import closeIcon from '../menu-bar/icon--close.svg';

import ProgressBar from './progress-bar.jsx';

import styles from './update-box.css';

import { Steps, Spin, Progress, Button } from 'antd';
// import { DownloadOutlined } from '@ant-design/icons';

let ipcRenderer
if (window.require) {

    ipcRenderer = window.require('electron').ipcRenderer;
}
const { Step } = Steps;

class UpdateBox extends React.Component {
    constructor() {
        super()
        this.state = {
            current: 0,
            check: "wait",  //success,error
            rate: 0,
            status: "process",
            updatePage: 0,
            errorMessage: false
        }
        bindAll(this, [
            'handleClickUpdate',
            'closeUpdateBox',
            'inputClick',
            'handleDownload',
            "handleCheckLink"
        ])
        ipcRenderer && ipcRenderer.on('firmware', (event, arg) => {
            window.__yourReactComp__.setState({
                updateProgress: 2,
                isUpdateBox: true
            })
            switch (arg) {
                case '1':
                    window.updateProps.setState({
                        current: 1,
                        check: "success",
                        status: "process",
                        updatePage: 3
                    })
                    console.log('成功')
                    break;
                case '2':
                    window.updateProps.setState({
                        current: 1,
                        check: "wait",
                        status: "process",
                        updatePage: 4
                    })
                    console.log('下载中')
                    break;
                default:
                    window.updateProps.setState({
                        current: 0,
                        check: "error",
                        status: "error",
                        rate: 0,
                        updatePage: 404,
                        errorMessage: arg.value
                    })
                    console.log('失败')
                    break;
            }
        })
    }
    componentDidMount() {
        window.updateProps = this
    }
    handleCheckLink() {

        this.setState({
            current: 0,
            check: "wait",
            status: "process",
            rate: 0,
            updatePage: 0,
            errorMessage: false
        })

        this.props.setupdateProgress(2);

        new Promise((resolve, reject) => {
            setTimeout(() => {
                // console.log(this.props)
                if (this.props.link) {
                    this.setState({
                        check: "success",
                        status: "process"
                    })
                    setTimeout(() => {
                        this.handleClickUpdate()
                    }, 1500)
                } else {
                    this.setState({
                        current: 0,
                        check: "error",
                        status: "error",
                        rate: 0,
                        updatePage: 404
                    })
                }
            }, 1500)
            resolve()
        })
    }
    // 点击更新发送下载固件指令
    handleClickUpdate() {

        if (this.props.vm.robotType == 'C1') {
            let json = {
                rcu: 'C1',
                command: 'HID_FIRMWARE_UPDATE'
            };
            const arg = JSON.stringify(json);
            ipcRenderer && ipcRenderer.send('udp_update', arg)
            console('已发送' + this.props.vm.robotType + '固件更新消息给主进程')
        } else if (this.props.vm.robotType == 'M5') {
            const data = new Buffer([0x86, 0xAB, 0x14, 0xE8, 0x80, 0x0A, 0x00, 0x00, 0x00, 0x00,
                0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0xCF
            ]);
            ipcRenderer && ipcRenderer.send('udp_trans', data);
            ipcRenderer && ipcRenderer.once('getmode-reply', (event, arg) => {
                let json = {
                    rcu: 'M5',
                    command: 'HID_FIRMWARE_UPDATE'
                };
                arg = JSON.stringify(json);
                ipcRenderer && ipcRenderer.send('udp_update', arg)
            })
        } else {
            let json = {
                rcu: this.props.vm.robotType,
                command: 'USB_FIRMWARE_UPDATE'
            };
            const arg = JSON.stringify(json);
            ipcRenderer && ipcRenderer.send('udp_update', arg)
            console.log('已发送' + this.props.vm.robotType + '固件更新消息给主进程')
        }

    }

    //关闭窗口
    closeUpdateBox() {
        this.props.setStateFalse('isUpdateBox')
    }

    //点击下载
    handleDownload() {
        // let json = {
        //     command: "GEN_APPLICATION_UPDATE",
        //     operation: "download"
        // };
        // const order = JSON.stringify(json);
        // jsObj.SendToBrowser(order);
        ipcRenderer && ipcRenderer.send('GEN_APPLICATION_UPDATE')
    }

    inputClick() {
        var dom = document.querySelectorAll("input[type='number']")[0]
        this.props.setupdateProgress(dom.value);
    }
    render() {
        const {
            updateProgress,
            version,
            intl,
            softwareVersion,
            isUpdateBox,
            vm
        } = this.props
        return (
            <div className={classNames(styles.transparentBg, { [styles.transparentBgHide]: !isUpdateBox })}>
                <div className={classNames(styles.tip10Update)}>

                    {/* 默认显示 */}
                    {updateProgress == 1 ? (
                        <div className={styles.updateBox1}>
                            <div className={styles.updateBox1Title}>
                                <FormattedMessage
                                    defaultMessage="Firmware Update"
                                    description="update Item"
                                    id="gui.menuBar.updateItem"
                                />
                                <div className={styles.closeUpdate} onClick={this.closeUpdateBox}>
                                    <img src={closeIcon} className={styles.closeIcon} alt="" />
                                </div>
                            </div>
                            <div className={styles.updateBox1Content}>
                                <div className={styles.updateContent}>
                                    {/* 第一步:请确保控制器连接成功<br/>
                                    点击更新<br/>
                                    第二步：正在下载固件（ps：请不要断开连接）<br/>
                                    第三步：正在安装固件<br/>
                                    第四步：安装成功（ps：请重新启动控制器）<br/> */}
                                    <div className={styles.versionName}>
                                        <FormattedMessage
                                            defaultMessage="controllerName"
                                            description="controller Name"
                                            id="gui.gui.controllerName"
                                        />
                                        <br />
                                        v{version.lastest}
                                    </div>
                                </div>
                                <div className={styles.updateSelect}>
                                    <button className={styles.updateClose}
                                        onClick={this.closeUpdateBox}
                                    >
                                        <FormattedMessage
                                            defaultMessage="Cancel"
                                            description="cancel"
                                            id="gui.gui.cancel"
                                        />
                                    </button>
                                    <button className={styles.updateOpen}
                                        onClick={this.handleCheckLink}
                                    >
                                        <FormattedMessage
                                            defaultMessage="Update"
                                            description="Update"
                                            id="gui.menuBar.update"
                                        />
                                    </button>
                                </div>
                            </div>
                        </div>) : null}


                    {/* 假如设备没连接 */}
                    {updateProgress == 5 ? (
                        <div className={styles.updateBox5Box}>
                            <div className={styles.updateBox4Text}>
                                <FormattedMessage
                                    defaultMessage="Your device is disconnected, please reconnect"
                                    description="Your device is disconnected, please reconnect"
                                    id="gui.gui.disconnected"
                                />
                            </div>
                            <div className={styles.updateBox4Ok} onClick={this.closeUpdateBox}>
                                <FormattedMessage
                                    defaultMessage="OK"
                                    description="OK"
                                    id="gui.gui.OK"
                                />
                            </div>
                        </div>
                    ) : null}

                    {/* 软件更新信息窗口 */}
                    {updateProgress == 6 ? (
                        <div>
                            <div>
                                <div className={styles.checkUpdate}>
                                    <FormattedMessage
                                        defaultMessage="Discovery of new versions :"
                                        description="Discovery of new versions"
                                        id="gui.gui.newVersions"
                                    />
                                    v{softwareVersion.lastest}
                                </div>
                                <div className={styles.closeUpdate} onClick={this.closeUpdateBox}>
                                    <img src={closeIcon} className={styles.closeIcon} alt="" />
                                </div>
                                <div className={styles.updateOperation}>
                                    <div onClick={this.handleDownload}>
                                        <FormattedMessage
                                            defaultMessage="Get a new version"
                                            description="Get a new version"
                                            id="gui.gui.getVersion"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : null}

                    {/* 判断软件如果没有新版本，则显示已是最新 */}
                    {updateProgress == 7 ? (
                        <div className={styles.updateBox7Box}>
                            <div className={styles.updateBox4Text}>
                                <FormattedMessage
                                    defaultMessage="Your SoftWare is the latest version"
                                    description="Your SoftWare is the latest version"
                                    id="gui.gui.newestVersion"
                                />
                                <br />
                                v{softwareVersion.current}
                            </div>
                            <div className={styles.updateBox4Ok} onClick={this.closeUpdateBox}>
                                <FormattedMessage
                                    defaultMessage="OK"
                                    description="OK"
                                    id="gui.gui.OK"
                                />
                            </div>
                        </div>
                    ) : null}

                    {/* 判断固件如果没有新版本，则显示已是最新 */}
                    {updateProgress == 8 ? (
                        <div className={styles.updateBox8Box}>
                            <div className={styles.updateBox4Text}>
                                <FormattedMessage
                                    defaultMessage="Your firmware is the latest version"
                                    description="Your firmware is the latest version"
                                    id="gui.gui.firmwareNewestVersion"
                                />
                                <br />
                                v{version.lastest}
                            </div>
                            <div className={styles.updateBox4Ok} onClick={this.closeUpdateBox}>
                                <FormattedMessage
                                    defaultMessage="OK"
                                    description="OK"
                                    id="gui.gui.OK"
                                />
                            </div>
                        </div>
                    ) : null}

                    {/* 反馈提交数据后成功提示 */}
                    {updateProgress == 9 ? (
                        <div className={styles.updateBox9Box}>
                            <div className={styles.updateBox4Text}>
                                <FormattedMessage
                                    defaultMessage="Submit success"
                                    description="Submit success"
                                    id="gui.gui.submitSuccess"
                                />
                            </div>
                            <div className={styles.updateBox4Ok} onClick={this.closeUpdateBox}>
                                <FormattedMessage
                                    defaultMessage="OK"
                                    description="OK"
                                    id="gui.gui.OK"
                                />
                            </div>
                        </div>
                    ) : null}

                    {/* 测试用显示窗口，便于查看窗口效果 */}
                    {/* <div style={{position:"absolute",top:"-50px",zIndex:'1000'}}><input type="number"/> <button onClick={this.inputClick}>确定</button></div> */}
                </div>
                {updateProgress == 2 ? (<div className={styles.updateBox}>
                    <Steps size="small" current={this.state.current} labelPlacement="vertical" status={this.state.status}>
                        <Step title={intl.messages['gui.gui.updateStep1']} />
                        {
                            (() => {
                                switch (this.props.vm.robotType) {
                                    case "C1":
                                        return <Step title={intl.messages['gui.gui.updateStep2-C1']} />
                                        break;
                                    case "E6":
                                        return <Step title={intl.messages['gui.gui.updateStep2-E6']} />
                                        break;
                                    case "M6":
                                        return <Step title={intl.messages['gui.gui.updateStep2-E6']} />
                                        break;
                                    default:
                                        break;
                                }
                            })()
                        }

                        {/* {this.props.vm.robotType == "C1" ? <Step title={intl.messages['gui.gui.updateStep2-C1']} /> :  <Step title={intl.messages['gui.gui.updateStep2-E6']} />} */}
                        {this.props.vm.robotType == "C1" ? <Step title={intl.messages['gui.gui.updateStep3-C1']} /> : null}

                    </Steps>
                    <div className={styles.updateBoxContent}>
                        <div className={styles.updateContentTop}>
                            {this.state.updatePage == 0 ? this.state.check == "wait" ? (
                                <div>
                                    <div className={styles.updateSmallBox}>
                                        <Spin size="large" />
                                    </div>
                                    <span>{intl.messages['gui.gui.checkLink']}</span>
                                </div>) : (<div>
                                    <span>{intl.messages['gui.gui.linkOk']}</span>
                                </div>) : null}

                            {this.state.updatePage == 1 ? (
                                <div>
                                    <div className={styles.updateSmallBox}>
                                        <Spin size="large" />
                                    </div>
                                    <span>
                                        {intl.messages['gui.gui.downloadFirmware']}
                                    </span>
                                </div>) : null}

                            {this.state.updatePage == 2 ? (
                                <div>
                                    <div className={styles.updateSmallBox}>
                                        <Progress type="circle" percent={this.state.rate} />
                                    </div>
                                    <span className={styles.updateText1}>
                                        {intl.messages['gui.gui.install']}
                                    </span>
                                </div>) : null}


                            {this.state.updatePage == 3 ? (
                                <div>
                                    {this.props.vm.robotType == "C1" ? (
                                        <span>{intl.messages['gui.gui.restartC1']}</span>
                                    ) : (
                                        <span>{intl.messages['gui.gui.restartE6']}</span>
                                    )}
                                    <div className={styles.updateCloseText}>
                                        <Button type="error" onClick={this.closeUpdateBox}>
                                            {intl.messages['gui.cards.close']}
                                        </Button>
                                    </div>
                                </div>) : null}

                            {this.state.updatePage == 4 ? (
                                <div>

                                    <div className={styles.updateSmallBox}>
                                        <Spin size="large" />
                                    </div>
                                    <span>
                                        正在下载固件到磁盘...
                                    </span>
                                </div>) : null}

                            {this.state.updatePage == 404 ? (<div>
                                {this.state.errorMessage ? (
                                    <span className={styles.updateText2}>{this.state.errorMessage}</span>
                                ) : null}
                                <span className={styles.updateText2}>{intl.messages['gui.gui.updateError']}</span>
                                <div className={styles.updateCloseText}>
                                    <Button type="primary" onClick={this.handleCheckLink}>
                                        {intl.messages['gui.gui.renew']}
                                    </Button>
                                    <Button type="error" onClick={this.closeUpdateBox}>
                                        {intl.messages['gui.cards.close']}
                                    </Button>
                                </div>
                            </div>) : null}

                        </div>

                        <span className={styles.updateTextTips}>
                            {intl.messages['gui.gui.firmwareTips']}
                        </span>
                    </div>
                </div>) : null}
            </div>

        )
    }
}

export default UpdateBox